import { usePlatformContext, usePlatformFeatureFlag } from "@datassential/platform-ui-lib";
import { WorkspaceEnum } from "@models/Workspace";
import LegacyWorkspace from "./variations/LegacyWorkspace";
import { WORKSPACE_COMPONENTS, WORKSPACE_DEFAULT_SECTIONS } from "./variations/config";
import { HomeWorkspaceProvider } from "./context/HomeWorkspaceContext";
import { useHomeWorkspaceResolution } from "./context/WorkspaceResolutionContext";

const Home = () => {
    const { isUserInfoLoaded } = usePlatformContext();
    const resolution = useHomeWorkspaceResolution();
    const isSalesWorkspaceEnabled = usePlatformFeatureFlag('SNAP Sales Workspace');
    const { workspaceId, chainId, chainName, isReady } = resolution;

    if (!isUserInfoLoaded) {
        return <div className="Home"/>;
    }

    const isSales = workspaceId === WorkspaceEnum.Sales;
    const WorkspaceComponent = workspaceId && (!isSales || isSalesWorkspaceEnabled) ? WORKSPACE_COMPONENTS[workspaceId] : null;

    if (!isReady || !workspaceId || !WorkspaceComponent) {
        return <LegacyWorkspace />;
    }

    return (
        <HomeWorkspaceProvider
            key={`${workspaceId}-${chainId ?? 'none'}`}
            workspaceId={workspaceId!}
            chainId={chainId}
            chainName={chainName}
            defaultVisibleSections={WORKSPACE_DEFAULT_SECTIONS[workspaceId]}
        >
            <WorkspaceComponent />
        </HomeWorkspaceProvider>
    );
};

export default Home;
